import { Dispatch } from "redux";
import { GetState } from "../config/store";
import { api } from "../config/api";
import {
    getNotificationsRequest,
    getNotificationsSuccess,
    getNotificationsFailure,
    putReadNotificationRequest,
    putReadNotificationSuccess,
    putReadNotificationFailure,
    setUnauthorized
} from "../reducers/notifications";
import { axiosClient } from "../config/axios";
import { accumulateRequest, setAccumulateRequest } from "../reducers/requests";
import { logOut } from "../reducers/auth";

export const getNotifications = (limit?: number) => (dispatch: Dispatch, getState: GetState) => _getNotifications(limit, dispatch, getState);
const _getNotifications = async (limit: number = 5, dispatch: Dispatch, getState: GetState) => {
    // First check if we're already unauthorized - if so, don't proceed with the request
    const isUnauthorized = getState().notifications?.unauthorized;
    if (isUnauthorized) {
        console.log('Skipping notification request due to previous 401 unauthorized error');
        return; // Exit immediately without making the request
    }

    try {
        const {fetchingFirstTime} = getState().auth;

        if(fetchingFirstTime){
            dispatch({type: accumulateRequest, payload: {function: getNotifications, params: {limit}, key: "getNotifications"} });
            return;
        }
        const userId = getState().auth.user?._id;
        if(!userId){
            const cachedRequests = getState().requests.data;
            if(cachedRequests?.length){
                cachedRequests.find((cachedRequest) =>{
                    if(cachedRequest?.key === "getNotifications"){
                        dispatch({type: setAccumulateRequest, payload: cachedRequests.filter((cached) => cached?.key !== "getNotifications") })
                    }
                })
            }
            return;
        }

        dispatch({ type: getNotificationsRequest });
        const token = getState().auth?.token;
        // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2ODA2NTYxY2ExYzA0OWE3NWE3ZWJmODgiLCJ0eXBlIjoiYWNjZXNzIiwiaWF0IjoxNzUzODA0MTM1LCJleHAiOjE3NTM4MDc3MzV9.KRTGOQyU9mhUNSeeq4dwlLgGe_bK3f0i1nluEYZgGK4';

        if (!token) {
            dispatch({ type: getNotificationsFailure });
            return;
        }

        const response = await axiosClient.get(`${api.notifications}?limit=${limit}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

        const cachedRequests = getState().requests.data;
        if(cachedRequests?.length){
            cachedRequests.find((cachedRequest) =>{
                if(cachedRequest?.key === "getNotifications"){
                    dispatch({type: setAccumulateRequest, payload: cachedRequests.filter((cached) => cached?.key !== "getNotifications") })
                }
            })
        }
        dispatch({type: getNotificationsSuccess, payload: response?.data?.data.notification});
    } catch (error: any) {
        const status = error?.response?.status;
        const errorMessage = error?.response?.data?.error || "Error al obtener notificaciones";
        
        if (error?.response?.status === 401 || error?.message === 'SESSION_EXPIRED') {
            dispatch({ type: setUnauthorized });
            dispatch({ type: getNotificationsFailure });
            dispatch({ type: logOut });
            return;
        } else {

            console.error("Error en getNotifications:", errorMessage);
            dispatch({ type: getNotificationsFailure});
        }
    }
};

export const putReadNotification = (notificationObject: {id: string, read: boolean, deleted: boolean}) => (dispatch: Dispatch, getState: GetState) => _putReadNotification(notificationObject, dispatch, getState);
const _putReadNotification = async (notificationObject: {id: string, read: boolean, deleted: boolean}, dispatch: Dispatch, getState: GetState) => {
    // Check if already unauthorized to prevent further requests
    const isUnauthorized = getState().notifications?.unauthorized;
    if (isUnauthorized) {
        console.log('Skipping notification update due to previous 401 unauthorized error');
        return; // Exit immediately without making the request
    }

    try {
        dispatch({type: putReadNotificationRequest});
        
        const body = JSON.stringify({read: notificationObject.read, deleted: notificationObject.deleted});

        const response = await axiosClient.put(`${api.notifications}/${notificationObject.id}`, body);

        dispatch({
            type: putReadNotificationSuccess, 
            payload: response?.data?.data.notification
        });
    } catch (error: any) {
        const status = error?.response?.status;
        const errorMessage = error?.response?.data?.error || "Error al actualizar notificación";
        
        if (status === 401) {
            // Marcar como no autorizado para prevenir futuros requests
            dispatch({ type: setUnauthorized });
            // Primero marcar la falla de la notificación antes de desconectar
            dispatch({ type: putReadNotificationFailure});
            // Dispatch logout al final para evitar que se vuelvan a solicitar notificaciones
            dispatch({ type: logOut });
            return; // Exit immediately to prevent further processing
        } else {
            console.error("Error en putReadNotification:", errorMessage);
            dispatch({ type: putReadNotificationFailure });
        }
    }
}